import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function ExpectedVsActualHelp() {
    return (
        <IconTooltip>
            <div>
                This chart provides a quick look at the volume traded in the
                market, comparing today&apos;s volume to the historical average
                in shares. This is displayed by time bins set in the
                chart&apos;s configuration <Icon name="cog" />.
            </div>
        </IconTooltip>
    );
}
